/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const WarehousePage = lazyLoad(
  () => import('./index'),
  module => module.WarehousePage
);
